import { Close } from "@mui/icons-material";
import {
  Autocomplete,
  Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select,
  TextField,
} from "@mui/material";
import  React, { useEffect } from "react";
import EventBus from "../../EventBus";
import {EventBusEventsEnum} from "../../enums/EventBusEventsEnum";
import {CustomSnackbarTypes} from "./CustomSnackBar";
import { useRefresh } from "react-admin";
import { useState } from "react";
import ChefForPartyService from "../../services/ChefForPartyService";
import {MealType} from "../../enums/MealType";

const chefForPartyService = new ChefForPartyService();

interface InputProps {
  data: any;
  open: boolean;
  callback: () => void;
}

const DishSelectorComp = (props: any) => {
    const [selectCategory, setSelectCategory] = useState<number>(0)
    const [dishes, setDishes] = useState<any>([])

    useEffect(() => {
        if (selectCategory !== 0) {
            chefForPartyService
                .getAllDishesForTypeAndCategory(selectCategory, props.type)
                .then((data) => setDishes(data))
                .catch((err) => setDishes([]));
        }
        chefForPartyService.getAllDishes()
            .then((data: any)=> setDishes(data?.data))
            .catch((err) => setDishes([]));  
    }, [selectCategory, props.type]);

    const handleDishSelect = (value: any) => {
        let index = props.index;
        props?.updateCallBack(value , index);
    }

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "4px", marginBottom: "8px" }}>
            {props?.showTitle && (
                <InputLabel id="type" style={{ fontWeight: 600, marginBottom: "4px" }}>{props.type}</InputLabel>
            )}
            <div style={{ display: "flex", gap: "16px", alignItems: "center", flexWrap: "wrap" }}>
                <FormControl style={{ minWidth: "220px", flex: "1 1 220px" }}>
                    <InputLabel id="type">{"Cuisine"}</InputLabel>
                    <Select
                        labelId="Cuisine"
                        id="Cuisine"
                        label="Cuisine"
                        defaultValue={''}
                        onChange={(event: any) => {
                            setSelectCategory(event.target.value);
                        }}
                    >
                        {props.category && Object.values(props.category).map((d: any) => (
                            <MenuItem key={d.id} value={d.id}>
                                {d.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {dishes && (
                    <FormControl style={{ minWidth: "280px", flex: "2 1 280px" }}>
                        <Autocomplete
                            options={dishes}
                            getOptionLabel={(option: any) => `${option.name} (${option?.mealType})` || ''}
                            onChange={(event, newValue) => {
                                handleDishSelect(newValue);
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Dish Name"
                                    variant="outlined"
                                    fullWidth
                                    placeholder="Select a Dish"
                                />
                            )}
                        />
                    </FormControl>
                )}
            </div>
        </div>
    );
}

export const EditDishesChefForParty = (props: InputProps) => {
    let refresh = useRefresh();

  const [category, setCategory] = useState([]);
  const [selectDishes, setSelectDishes] = useState<any>([]);

  let handleClose = () => {
    props.callback();
      setSelectDishes([]);
      // setSelectDish(null);
  }

  useEffect(() => {
    chefForPartyService
      .getAllCategory()
      .then((data: any) => setCategory(data))
      .catch((err) => setCategory([]));
  }, []);

    useEffect(() => {
        if(!props?.data){
            return;
        }
        let {noOfStarters, noOfMainCourse, noOfDesserts, noOfSideDishes, noOfBeverages } = props?.data;
        const starters = Array.from({ length: noOfStarters }, () => ({ type: MealType.STARTER, item: null }));
        const mainCourse = Array.from({ length: noOfMainCourse }, () => ({ type: MealType.MAIN_COURSE, item: null }));
        const desserts = Array.from({ length: noOfDesserts }, () => ({ type: MealType.DESSERT, item: null }));
        const sideDishes = Array.from({ length: noOfSideDishes }, () => ({ type: MealType.SIDE_DISH, item: null }));
        const beverages = Array.from({ length: noOfBeverages || 0 }, () => ({ type: MealType.BEVERAGE, item: null }));
       const allDishes = [...starters, ...mainCourse, ...desserts, ...sideDishes, ...beverages];
        setSelectDishes([...allDishes]);
    }, [props?.data]);

  return (
      <Dialog
        onClose={handleClose}
        open={props.open}
        scroll={"paper"}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Edit/Add Dishes</DialogTitle>
        <DialogContent sx={{ padding: "24px", minWidth: 0 }}>
          <IconButton onClick={handleClose} sx={{ position: 'absolute', top: 2, right: 5 }}> <Close /> </IconButton>
            {selectDishes.map((e: any,i: number) =>
                <DishSelectorComp
                    key={`${e.type}-${i}`}
                    index={i}
                    showTitle={selectDishes?.[i - 1]?.type !== e?.type}
                    category={category}
                    type={e.type}
                    selectDishes={selectDishes}
                    setSelectDishes={setSelectDishes}
                    updateCallBack={(item: any, index: number)  => {
                        selectDishes[index].item = item;
                        setSelectDishes([...selectDishes]);
                    }}
                />
            )}
        </DialogContent>
        <DialogActions style={{ marginTop: "12px" }}>
          <Button
            variant="contained"
            onClick={() => {
              chefForPartyService
              .addDIshChefForParty(props.data.id, {dishes: selectDishes?.filter((item: any) => item?.item !== null).map((item: any)=> item?.item)})
                .then((res) => {
                    EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                        message: "Added Successfully",
                        type: CustomSnackbarTypes.SUCCESS,
                    });
                  refresh();
                  handleClose();
                });
            }}
            size={"large"}
          >
            Submit
          </Button>
          <Button
            variant="contained"
            color={"error"}
            onClick={() => {
              handleClose();
            }}
            size={"large"}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
  );
};
